export default {
  computed: {
    statusOptions: function statusOptions() {
      return [{
        value: 'todo',
        name: this.$t('mixins.todo')
      }, {
        value: 'in_progress',
        name: this.$t('general.in_progress')
      }, {
        value: 'completed',
        name: this.$t('general.done')
      }];
    },
    priorityOptions: function priorityOptions() {
      return [{
        value: 'low',
        name: this.$t('priorities.low')
      }, {
        value: 'medium',
        name: this.$t('priorities.medium')
      }, {
        value: 'high',
        name: this.$t('priorities.high')
      }];
    }
  }
};